export const PartnerScoreDataAvailabilityArrowSort = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame 427319949">
        <path
          id="Icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.138462 7.15295C-0.0461538 7.33756 -0.0461538 7.59141 0.138462 7.77602L3.6 11.1683C3.78462 11.3529 4.06154 11.3529 4.24615 11.1683L7.73077 7.77602C7.91538 7.59141 7.91538 7.33756 7.73077 7.15295L7.08462 6.52987C6.9 6.34525 6.62308 6.34525 6.43846 6.52987L5.35385 7.59141C5.16923 7.77602 4.84615 7.66064 4.84615 7.38371V1.15294C4.84615 0.922175 4.63846 0.691406 4.38462 0.691406H3.46154C3.20769 0.691406 3 0.945252 3 1.15294V7.38371C3 7.66064 2.67692 7.77602 2.49231 7.59141L1.40769 6.52987C1.22308 6.34525 0.946154 6.34525 0.761538 6.52987L0.138462 7.15295Z"
          fill="#544F4F"
        />
      </g>
    </svg>
  );
};
